export const CLASS_NAME = 'cst-icon-arrow-up-right'
